export default __webpack_public_path__ + "static/media/App.31d6cfe0.less";